import React, { Component } from 'react';
import axios from 'axios'
import BillBoard from '../../advertisements/BillBoard';
import authservice from '../../Authentication/service/authservice';
import DateRangePicker from 'react-daterange-picker';
import "react-daterange-picker/dist/css/react-calendar.css";
import moment from 'moment';
import { TitleHeading } from '../../UIElements/headings/TitleHeading';
import { ButtonStyle } from '../../UIElements/Buttons/ButtonStyle';
import styles from '../../listings/forms/addpost.module.css';
import './performance.css'
import LargeRectangle from '../../advertisements/LargeRectangle';
import Moment from 'react-moment';

class MembershipWithdrawalHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            withdrawal: [],
            currentPage: 0,
        }
    }

    componentDidMount = () => {
        const page = this.state.currentPage;
        window.scroll(0, 0);
        this.currentUserId = this.props.isAdmin ? this.props.userId : authservice.getCurrentUserid()
        axios.get(process.env.REACT_APP_BACKEND_URL + `/abmgr/revenue/commission-history/${this.currentUserId}/?page=${page}`)
            .then(response => {
                if (response.data) {
                    const withdrawal = response.data.data ? response.data.data : []
                    this.setState({ withdrawal })
                }
            }).catch(error => {
                console.log(error)
            })

    }


    renderwithdrawalhistory() {
        return this.state.withdrawal.map((user, index) => {
            const { orderType, sourceUserName, userType, amount, withdrawn, settlementDate, withdrawalStatus } = user //destructuring
            return (
                <tr id={'parent-row-' + settlementDate} className="table-row extra_height" key={settlementDate}>
                    <td>{index + 1}</td>
                    <td>{sourceUserName}</td>
                    {/* <td>{userType}</td> */}
                    <td>{orderType}</td>
                    <td>{moment(settlementDate).format("DD MMM YYYY, hh:mm A")}</td>
                    <td>{amount}</td>
                    {/* <td>{withdrawn ? 'Yes' : 'No'}</td> */}
                    <td>{withdrawalStatus}</td>
                </tr>
            )
        })
    }

    render() {
        return (
            <>
                <div className='desktop_viewreport'>
                    <div className='ad_container'>
                        <div>
                            <div className='ViewPerformance'>
                                <TitleHeading text={'Membership Withdrawal History'} />
                            </div>
                            <table id='posts' className="col-md-12 tr_marginTop">
                                <tbody>
                                    <tr className="table-row extra_height">
                                        <th className='td_width'>S.No.</th>
                                        <th className='user_width'>User Name</th>
                                        {/* <th className='posted_width'>User Type</th> */}
                                        <th className='posted_width'>Order Type</th>
                                        <th className='user_width'>Date of Settlement</th>
                                        <th className='posted_width'>Amount</th>
                                        {/* <th className='td_width'>Withdraw</th> */}
                                        <th className='user_width'>Withdrawal Status</th>
                                    </tr>
                                    {this.renderwithdrawalhistory()}
                                </tbody>
                            </table>
                            <div className="ViewPerformance listing_type_tabs">
                                <div className="col-md-9"></div>
                                {!this.props.isAdmin
                                    && <div className="col-md-3 add_button animated_back_button">
                                        <ButtonStyle type="button" className="form-control btn btn-block btn_font"
                                            handleClick={() => this.props.history.goBack()}>&nbsp; &laquo; &nbsp; Go Back To Dashboard </ButtonStyle>
                                    </div>}
                            </div>
                        </div>

                    </div>
                    {!this.props.isAdmin &&
                        <div className='ad_marginTop row' style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
                            <BillBoard spot={"-1"} />
                        </div>}
                </div>
                <div className='mobile_viewreport'>
                    <div className='ad_container'>
                        <div>
                            <div className='ViewPerformance'>
                                <TitleHeading text={'Membership Withdrawal History'} />
                            </div>
                            <table id='posts' className="col-md-12 tr_marginTop">
                                <tbody>
                                    <tr className="table-row extra_height">
                                        <th className='td_width'>S.No.</th>
                                        <th className='user_width'>User Name</th>
                                        {/* <th className='posted_width'>User Type</th> */}
                                        <th className='posted_width'>Order Type</th>
                                        <th className='user_width'>Date of Settlement</th>
                                        <th className='posted_width'>Amount</th>
                                        {/* <th className='td_width'>Withdraw</th> */}
                                        <th className='user_width'>Withdrawal Status</th>
                                    </tr>
                                    {this.renderwithdrawalhistory()}
                                </tbody>
                            </table>
                            <div className="ViewPerformance listing_type_tabs">
                                <div className="col-md-9"></div>
                                {!this.props.isAdmin
                                    && <div className="col-md-3 add_button animated_back_button">
                                        <ButtonStyle type="button" className="form-control btn btn-block btn_font"
                                            handleClick={() => this.props.history.goBack()}>&nbsp; &laquo; &nbsp; Back</ButtonStyle>
                                    </div>}
                            </div>
                        </div>

                    </div>
                    <div className={`listings row ${styles.large_rect}`}>
                        {!this.props.isAdmin && <LargeRectangle spot={"-1"} />}
                    </div>
                </div>
            </>
        )
    }
}

export default MembershipWithdrawalHistory;